import React from 'react';
import {LinearProgress, Stack, Typography} from '@mui/material';
import {StyleSx} from 'app/types/common';

const rootSx: StyleSx = {width: '100vw', height: '100vh'};
const progressSx: StyleSx = {width: 400};

interface Props {
  progress: number;
}

export function InitPage({progress}: Props) {
  return (
    <Stack sx={rootSx} justifyContent="center" alignItems="center">
      <Typography variant="h5" mb={3}>
        Starting application
      </Typography>
      <LinearProgress sx={progressSx} variant="determinate" value={progress} />
    </Stack>
  );
}
